import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
var render = function render() {
  var _class;
  var _vm = this,
    _c = _vm._self._c;
  return _vm.$slots.default ? _c('ul', {
    staticClass: "vertical-list",
    class: (_class = {}, _defineProperty(_class, 'col-' + _vm.number, true), _defineProperty(_class, 'hide-bottom-margin', _vm.hideBottomMargin), _class)
  }, [_vm.$slots.default[0].tag === 'li' ? [_vm._t("default")] : _vm._l(_vm.$slots.default, function (item, index) {
    return !item.isComment && (_vm.$slots['temp' + index] = item) ? _c('li', [_vm._t('temp' + index)], 2) : _vm._e();
  })], 2) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };